import { Heading, Link } from '@thirstycamel/ui'
import { useWindowSize } from '../../pages/hump-club'
import HumpClubLandingFaq from '../HumpClubLandingFaq'
import React, { useRef, useEffect, useState } from 'react'

export default function HumpClubLandingFooter() {
  const isMobile = useWindowSize()

  return (
    <>
      <div style={{ position: 'relative' }}>
        <img src="/static/images/hump-club-landing/waves3.png" alt="Hump Club Rewards" />
      </div>
      <div style={{ position: 'relative' }}>
        <img
          src={
            isMobile
              ? '/static/images/hump-club-landing/waves4_mobile.png'
              : '/static/images/hump-club-landing/waves4_desktop.png'
          }
          alt="Hump Club Rewards"
          style={{ pointerEvents: 'none', display: 'block', width: '100%' }}
        />
        <div className="footer-content-container">
          <div
            className="discover-offers-heading"
            style={{
              marginBottom: isMobile ? '0rem' : '0.8rem',
            }}
          >
            Discover your my offers!
          </div>
          <Link href="/account/offers">
            <button className="shop-now-button">Shop Now</button>
          </Link>
        </div>
        <div className="footer-faq-container">
          <HumpClubLandingFaq />
        </div>
      </div>
    </>
  )
}
